/* Pageviews only. Shopify remains the source of truth for analytics consent. */
(function () {
  'use strict';
  if (window.__panchonaPostHog || window.posthog) return;
  window.__panchonaPostHog = true;

  var started = false;
  var client = null;
  var captured = false;
  var attempts = 0;

  function allowed() {
    try {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function pageview() {
    if (!client || captured || !allowed()) return;
    captured = true;
    client.capture('$pageview');
  }

  function start() {
    if (started || window.posthog || !allowed()) return;
    started = true;
    // Official PostHog asynchronous loader. No store UI or purchase listeners.
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog&&window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split('.');2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement('script')).type='text/javascript',p.crossOrigin='anonymous',p.async=!0,p.src=s.api_host.replace('.i.posthog.com','-assets.i.posthog.com')+'/static/array.js',p.onerror=function(){p=null},(r=t.getElementsByTagName('script')[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a='posthog',u.people=u.people||[],o='init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep'.split(' '),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

    window.posthog.init('phc_zQtajaE5bRzSQFJZjV2ZxqTeS3XoP62CJE6VjnhANCsC', {
      api_host: 'https://us.i.posthog.com',
      ui_host: 'https://us.posthog.com',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      capture_dead_clicks: false,
      capture_exceptions: false,
      capture_heatmaps: false,
      capture_performance: false,
      rageclick: false,
      disable_session_recording: true,
      disable_surveys: true,
      disable_web_experiments: true,
      disable_conversations: true,
      disable_external_dependency_loading: true,
      advanced_disable_flags: true,
      advanced_disable_decide: true,
      remote_config_refresh_interval_ms: 0,
      person_profiles: 'never',
      mask_all_text: true,
      mask_all_element_attributes: true,
      enable_recording_console_log: false,
      logs: { captureConsoleLogs: false },
      ip: false,
      respect_dnt: true,
      persistence: 'cookie',
      secure_cookie: true,
      cross_subdomain_cookie: false,
      save_referrer: false,
      store_google: false,
      request_batching: false,
      before_send: function (event) {
        if (!allowed() || event.event !== '$pageview') return null;
        // Explicit allowlist: no form values, customer data, query strings or hashes.
        var clean = {};
        ['token', 'distinct_id', '$lib', '$lib_version', '$session_id', '$window_id',
          '$browser', '$browser_version', '$os', '$os_version', '$device_type',
          '$screen_height', '$screen_width', '$viewport_height', '$viewport_width'
        ].forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(event.properties, key)) clean[key] = event.properties[key];
        });
        clean.$current_url = window.location.origin + window.location.pathname;
        clean.$pathname = window.location.pathname;
        clean.$host = window.location.host;
        clean.$process_person_profile = false;
        clean.$is_identified = false;
        clean.$geoip_disable = true;
        event.properties = clean;
        return event;
      },
      loaded: function (instance) {
        client = instance;
        updateConsent();
      }
    });
  }

  function updateConsent() {
    if (!allowed()) {
      if (client) client.opt_out_capturing();
      return;
    }
    if (!started) start();
    if (client) {
      if (client.has_opted_out_capturing()) client.opt_in_capturing({ captureEventName: false });
      pageview();
    }
  }

  function prepare() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      updateConsent();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) updateConsent();
      });
    } else if (++attempts < 20) {
      window.setTimeout(prepare, 250);
    }
  }

  document.addEventListener('visitorConsentCollected', updateConsent);
  prepare();
}());
